export default __webpack_public_path__ + "f68115c45c5c5c80b9303a5382070df3.png";